import { WidgetLinkingID } from '@benzinga/widget-linking';
import { SearchItem } from './module';

export const LinkingModuleId = 'Linking' as const;

//Legacy

//V1
export interface LinkingSearchItemDataV1 {
  linkId: NonNullable<WidgetLinkingID>;
}

export const LinkingSearchItemVersionV1 = '1' as const;

export interface LinkingSearchItemV1 extends SearchItem<LinkingSearchItemDataV1> {
  version: typeof LinkingSearchItemVersionV1;
  moduleId: typeof LinkingModuleId;
}

export type LegacyLinkingSearchItem = LinkingSearchItemV1;

// Current

export type LinkingSearchItemData = LinkingSearchItemDataV1;

export const LinkingSearchItemVersion = LinkingSearchItemVersionV1;

export type LinkingSearchItem = LinkingSearchItemV1;

export const LinkingItemSpecifier = '+';

export const createLinkingSearchItem = (linkId: NonNullable<WidgetLinkingID>): LinkingSearchItem => ({
  data: {
    linkId,
  },
  id: linkId,
  moduleId: LinkingModuleId,
  version: LinkingSearchItemVersion,
});

export const isLegacyLinkingSearchItem = (item: SearchItem): item is LegacyLinkingSearchItem =>
  item?.moduleId === LinkingModuleId;

export const isLinkingSearchItem = (item: SearchItem): item is LinkingSearchItem =>
  item?.moduleId === LinkingModuleId && item?.version === LinkingSearchItemVersion;
